import React, { useState, useContext } from 'react';
import Fab from '@mui/material/Fab';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import {
    Routes,
    Link,
    Route,
    useNavigate,
    useParams
} from 'react-router';
import EditItem from './edit-item';
import CrudList from './list';
import CrudContext from './crud-context';
import ModelTypes from './model-types';
import crudDefinitions from './crud-defs';
import uuid from 'short-uuid';
import AppContext from '../app-context';
import { useFirebase } from '../firebase-context';
import { PageContainer } from '@toolpad/core/PageContainer';

const FirebaseCrud = ({ definition }) => {
    const navigate = useNavigate();
    const { accessLevel } = useContext(AppContext);

    const [entityState, setXEntityState] = useState({});
    const [formState, setXFormState] = useState({});

    const providerValue = {
        ...{ fields: [], storageKey: '', crumbs: [] },
        ...crudDefinitions[definition],
        entityState,
        setEntityState,
        formState,
        setFormState,
        hardSetFormState,
        hardSetEntityState
    };
    
    function startNewItem() {
        const { modelType } = providerValue;
        const newid = uuid.generate();
        let newUrl = `./${newid}`;
        if (modelType === ModelTypes.USEROWNEDLIST && accessLevel === 1) {
            const { uid } = firebase.auth().currentUser;
            newUrl = `./${uid}%2F${newid}`
        }
        navigate(newUrl);
    }

    function setEntityState(newState) {
        setXEntityState({
            ...entityState,
            ...newState
        });
    }

    function hardSetEntityState(newState) {
        setXEntityState(newState);
    }

    function setFormState(newState) {
        setXFormState({
            ...formState,
            ...newState
        });
    }

    function hardSetFormState(newState) {
        setXFormState(newState);
    }

    const { modelType } = crudDefinitions[definition];

    const canAddItems = modelType === ModelTypes.USEROWNEDLIST || modelType === ModelTypes.ENUM;

    const skipList = accessLevel < 2 && modelType === ModelTypes.SOLO;

    return (<React.Fragment>
        <CrudContext.Provider value={ providerValue }>
            <div style={ { margin: 24 } }>
                <Routes>
                    <Route index element={ skipList ? 'Unauthorized' : <CrudList definition={ definition } /> } />
                    <Route path=":id" element={ <EditItem definition={ definition } /> } />
                </Routes>
            </div>
            <div style={ { height: 300} }>  </div>
            {
                canAddItems && (<Fab color="primary" style={ { position: 'fixed', right: '5vw', bottom: '5vh' } }>
                <AddIcon onClick={ startNewItem } />
            </Fab>)
            }
        </CrudContext.Provider>
    </React.Fragment>
    );
};

export default FirebaseCrud;
